import { PhosphorCaretLeftAnchor, PhosphorCaretRightAnchor } from "components/Atoms/PhosphorIconAnchor";
import OptionsPanel from "components/panels/OptionsPanel";
import React from "react";
import { DeleteDialog } from "../../../components";
import ShortcutsApp from "components/Shortcuts/app";

interface Props {
  optionsPanel: server.dto.OptionsPanelDataV2
  listUrl: string
  invoice: server.dto.InvoiceV2
  copyUrl: string
}

const InvoiceV2OptionsPanel = (props: Props) => {
  const {
    optionsPanel,
    listUrl,
    invoice,
  } = props;

  const [isDeleting, setIsDeleting] = React.useState(false);

  const onDelete = async () => {
    await window.CoreApi.Invoice.Delete({ invoiceId: invoice.documentId });
    // We need to check the outcomeDto if there are any errors. If there are any errors, we need to show them to the user.
    // If none, we can redirect the user to the overview page.
    window.location.href = listUrl;
    setIsDeleting(false);
  };

  return <OptionsPanel title={RESX.OptionsPanel.Options}>

    <div className="flex-column gap">
      {/* {site.permissions.invoice.canCreate && <div>
        <a href={copyUrl}>{RESX.Buttons.btnCopy}</a>
      </div>} */}

      {invoice.permissions.canDelete && <a onClick={() => { setIsDeleting(true); }}>
        {RESX.Buttons.btnDelete}
      </a>}

      <div>
        <a href={listUrl}>
          {RESX.Buttons.ListView}
        </a>
      </div>
    </div>

    <div>
      <ShortcutsApp
        shortcutOrder={["recipient", "show", "note"]}
      />
    </div>

    <div className="flex justify-space-between align-center">
      <PhosphorCaretLeftAnchor
        layout="in-square"
        href={optionsPanel.previousUrl} />

      <div>
        {optionsPanel.currentPosition} / {optionsPanel.recordCount}
      </div>

      <PhosphorCaretRightAnchor
        layout="in-square"
        href={optionsPanel.nextUrl} />
    </div>

    <DeleteDialog
      isOpen={isDeleting}
      message={RESX.GeneralWarnings.AreYouSure}
      handleClose={() => { setIsDeleting(false); }}
      onDelete={onDelete} />
  </OptionsPanel>;
};

export default InvoiceV2OptionsPanel;